import React from 'react';
import { useTranslation } from 'react-i18next';

function ConsultationCommentSuccess(props) {
    
    const { t, i18n } = useTranslation();

    return (
        <h1>{t('comment-form.label.submit-success')}</h1>
    );
}

export default ConsultationCommentSuccess;